import { render } from "./ModelView.vue?vue&type=template&id=0dc6feae&scoped=true"
import script from "./ModelView.vue?vue&type=script&lang=js"
export * from "./ModelView.vue?vue&type=script&lang=js"

import "./ModelView.vue?vue&type=style&index=0&id=0dc6feae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\WONHAP\\Websites\\aswo-api\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc6feae"]])

export default __exports__